import { SENSOR_FUSION_DATA_LAYERS } from '@/types/shared/navigation-tabs.enums';

interface Graph {
  id: string;
  enabled: boolean;
  [key: string]: any;
}

interface Config {
  dataLayers?: Array<{
    id: string;
    graphs?: Graph[];
  }>;
}

interface InitialEnabledGraphs {
  [key: string]: string[];
}

/**
 * Initialize enabled graphs based on config
 */
export function initializeEnabledGraphs(spectrumAnalysisGraphs: Graph[]): InitialEnabledGraphs {
  return {
    [SENSOR_FUSION_DATA_LAYERS.SPECTRUM_ANALYSIS]: spectrumAnalysisGraphs
      .filter((el: any) => el.enabled)
      .map((el: any) => el.id),
  };
}

/**
 * Create initialization key for tracking graph config changes
 */
export function createInitializationKey(
  selectedComponentId: string | null | undefined,
  selectedPart: string | null | undefined,
  spectrumAnalysisGraphs: Graph[]
): string {
  return `${selectedComponentId}-${selectedPart}-${spectrumAnalysisGraphs.length}`;
}
